export const CUSTOM_LINEAR_3_TEMPLATE = {
    id: 'custom-linear-3',
    label: 'Custom Linear 3',
    cards: 3,
    family: 'triad',
    layout_id: 'linear-3',
    positions: [
        { role_id: 'custom', name: 'Posizione 1', description: 'Prima lente del template lineare.' },
        { role_id: 'custom', name: 'Posizione 2', description: 'Centro o nodo del template lineare.' },
        { role_id: 'custom', name: 'Posizione 3', description: 'Terza lente del template lineare.' },
    ],
    tags: ['diagnostic', 'self-study'],
};
export const CUSTOM_LINE_5_TEMPLATE = {
    id: 'custom-line-5',
    label: 'Custom Line 5',
    cards: 5,
    family: 'line',
    layout_id: 'line-5',
    positions: [
        { role_id: 'custom', name: 'Nodo 1', description: 'Primo nodo della linea.' },
        { role_id: 'custom', name: 'Nodo 2', description: 'Secondo nodo della linea.' },
        { role_id: 'custom', name: 'Nodo 3', description: 'Cuore della linea.' },
        { role_id: 'custom', name: 'Nodo 4', description: 'Quarto nodo della linea.' },
        { role_id: 'custom', name: 'Nodo 5', description: 'Ultimo nodo della linea.' },
    ],
    tags: ['diagnostic', 'decision'],
};
export const CUSTOM_GRID_6_TEMPLATE = {
    id: 'custom-grid-6',
    label: 'Custom Grid 6',
    cards: 6,
    family: 'grid',
    layout_id: 'custom-grid-6',
    positions: [
        { role_id: 'custom', name: 'Cella 1', description: 'Primo nodo della griglia.' },
        { role_id: 'custom', name: 'Cella 2', description: 'Secondo nodo della griglia.' },
        { role_id: 'custom', name: 'Cella 3', description: 'Terzo nodo della griglia.' },
        { role_id: 'custom', name: 'Cella 4', description: 'Quarto nodo della griglia.' },
        { role_id: 'custom', name: 'Cella 5', description: 'Quinto nodo della griglia.' },
        { role_id: 'custom', name: 'Cella 6', description: 'Sesto nodo della griglia.' },
    ],
    tags: ['diagnostic', 'self-study'],
};
export const CUSTOM_CIRCLE_12_TEMPLATE = {
    id: 'custom-circle-12',
    label: 'Custom Circle 12',
    cards: 12,
    family: 'custom',
    layout_id: 'custom-circle-12',
    positions: Array.from({ length: 12 }, (_, index) => ({
        role_id: 'custom',
        name: `Settore ${index + 1}`,
        description: `Settore ${index + 1} del cerchio personalizzato.`,
    })),
    tags: ['forecast', 'ritual', 'self-study'],
};
export const CUSTOM_SPREAD_TEMPLATE_PRESETS = [
    CUSTOM_LINEAR_3_TEMPLATE,
    CUSTOM_LINE_5_TEMPLATE,
    CUSTOM_GRID_6_TEMPLATE,
    CUSTOM_CIRCLE_12_TEMPLATE,
];
//# sourceMappingURL=template-presets.js.map